import _ from 'lodash'
import axios from "../axios";
import { IWxInformationListData, IWxInformationListParams } from './wxinformation.types';

/**
 * 解绑
 */
export function wxInformationDelete(id: number) {
    return axios({
        method: 'delete',
        url: `/wxInfomation/delete/${id}`
    })
}

export function wxInformationList(params: IWxInformationListParams) {
    return axios<IWxInformationListData>({
        method: 'get',
        url: '/wxInfomation/findPage',
        params,
    })
}
